export default {
notification: {
  read: "Telah dibaca",
  unread: "Belum dibaca",
  hide: "Sembunyikan",
  showAll: "Tunjukkan semua",
  loading: "Memuatkan...",
  noMore: "Tiada lagi data",
  platform: "Platform",
  personal: "Peribadi"
}
};
